import { jsx as _jsx } from "react/jsx-runtime";
export const AIWorkflowsIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1779785731/Generator_featured%20images/Growth/Classic/Acceleration/Workflows.png",
        width: "18",
        height: "18",
        alt: ""
    });
